var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Textarea } from '../Textarea/index.js';
import { FormControlMeta } from './FormControlMeta.js';
import { Label } from './Label.js';
export const FormControlTextarea = forwardRef((props, ref) => {
    const { name, label, placeholder, helperText, cornerHint, error, invalid } = props, rest = __rest(props, ["name", "label", "placeholder", "helperText", "cornerHint", "error", "invalid"]);
    return (React.createElement("div", null,
        label ? (React.createElement(Label, { htmlFor: name, helperText: cornerHint }, label)) : null,
        React.createElement("div", { className: clsx(!!label && 'mt-1') },
            React.createElement(Textarea, Object.assign({ name: name, id: name, placeholder: placeholder, invalid: invalid, ref: ref }, rest)),
            React.createElement(FormControlMeta, Object.assign({}, { helperText, error, invalid })))));
});
//# sourceMappingURL=FormControlTextarea.js.map